import React from 'react';
import { useState, useEffect } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { Link } from "react-router-dom";
import {
  Box,
  Button,
  ButtonGroup,
  Card,
  CardHeader,
  CardContent,
  Divider,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TablePagination,
  TableContainer,
  TextField
} from '@mui/material';
// import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
// import CircularProgress from '@mui/material/CircularProgress';
// import Chip from '@mui/material/Chip';
// import SearchField from "react-search-field";
// import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
// import Popover from '@mui/material/Popover';
// import Typography from '@mui/material/Typography';
// import Paper from '@mui/material/Paper';
// import MenuItem from '@mui/material/MenuItem';
// import MenuList from '@mui/material/MenuList';
// import Edit from './Edit';



const delay = 5;

const LabList = ({ ...rest }) => {

  //  Instance List //
  
  const [customiziationRequestlist, setCustomiziationRequestlist] = useState([]); 
  // console.log(customiziationRequestlist);

  useEffect(() => {    
    fetch(`${process.env.REACT_APP_API_URL}/api/customizationrequestadminlist/`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((resp) => resp.json())
      .then((data) => setCustomiziationRequestlist(data))
      .catch((error) => {
        console.error(error);
      });         
  }, []);

  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // const emptyRows = rowsPerPage - Math.min(rowsPerPage, customiziationRequestlist.length - page * rowsPerPage);

  const [anchorEl, setAnchorEl] = React.useState(null);

  // const handleClick = (event) => {
  //   setAnchorEl(event.currentTarget);
  // };

  // const handleClose = () => {
  //   setAnchorEl(null);
  // };

  const open = Boolean(anchorEl);

  // const id = open ? 'simple-popover' : undefined;  

  // const [selectedIndex, setSelectedIndex] = React.useState(0);

  // const handleMenuItemClick = (event, index) => {
  //   setSelectedIndex(index);
  // };  

  // const [searchitems, setSearchItems] = React.useState(0);

  return (
    <>
    <Box sx={{ pt: { xs: 1, sm: 2, md: 3 }, px: { xs: 1, sm: 2 } }}>
    <Card {...rest}>
      <PerfectScrollbar>
        <TableContainer sx={{ overflowX: 'auto' }}>
          <Table sx={{ minWidth: { xs: '100%', sm: 650 } }}>
            <TableHead>
              <TableRow>
                <TableCell sx={{ 
                  fontSize: { xs: '0.75rem', sm: '0.875rem', md: '0.9375rem' },
                  fontWeight: 'bold',
                  py: { xs: 1, sm: 1.5 },
                  px: { xs: 1, sm: 2 }
                }}>
                 No
                </TableCell>
                <TableCell 
                  align="left"
                  sx={{ 
                    fontSize: { xs: '0.75rem', sm: '0.875rem', md: '0.9375rem' },
                    fontWeight: 'bold',
                    py: { xs: 1, sm: 1.5 },
                    px: { xs: 1, sm: 2 }
                  }}
                >
                 Status
                </TableCell>               
                {/* <TableCell align="left">
                  Date
                </TableCell> */}
                <TableCell 
                  align="left"
                  sx={{ 
                    fontSize: { xs: '0.75rem', sm: '0.875rem', md: '0.9375rem' },
                    fontWeight: 'bold',
                    py: { xs: 1, sm: 1.5 },
                    px: { xs: 1, sm: 2 }
                  }}
                >
                  Description
                </TableCell> 
                            
              </TableRow>
            </TableHead>  
            { customiziationRequestlist.length > 0 ?         
            <TableBody >
              {customiziationRequestlist
              // .filter((val) => {
              //   if (searchitems == "") {
              //     return val;
              //   } else if ( (val[options[selectedIndex].value]).toLowerCase().includes(searchitems.toLowerCase())){
              //     return val;
              //   }
              // })
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((instance) => 
                            
              (
                <TableRow
                  hover
                  key={instance.id}
                >
                  <TableCell sx={{ 
                    fontSize: { xs: '0.75rem', sm: '0.875rem' },
                    py: { xs: 1, sm: 1.5 },
                    px: { xs: 1, sm: 2 },
                    whiteSpace: { xs: 'nowrap', sm: 'normal' }
                  }}>
                    {instance.random_number}
                  </TableCell>                    
                  <TableCell 
                    align="left"
                    sx={{ 
                      fontSize: { xs: '0.75rem', sm: '0.875rem' },
                      py: { xs: 1, sm: 1.5 },
                      px: { xs: 1, sm: 2 },
                      wordBreak: { xs: 'break-word', sm: 'normal' }
                    }}
                  >
                    {instance.status}
                  </TableCell>
                  {/* <TableCell align="left">
                    {instance.date_time}
                  </TableCell>                   */}
                  <TableCell 
                    align="left"
                    sx={{ 
                      fontSize: { xs: '0.75rem', sm: '0.875rem' },
                      py: { xs: 1, sm: 1.5 },
                      px: { xs: 1, sm: 2 },
                      wordBreak: 'break-word',
                      maxWidth: { xs: '200px', sm: 'none' }
                    }}
                  >
                    {instance.details}
                  </TableCell>
                      
                </TableRow>              
              )
              )}
            </TableBody> 
            : 
            <TableBody>
              <TableRow>
                <TableCell 
                  colSpan={3}
                  align="center"
                  sx={{ 
                    fontSize: { xs: '0.75rem', sm: '0.875rem' },
                    py: { xs: 3, sm: 4 },
                    px: { xs: 1, sm: 2 }
                  }}
                > 
                  No data available
                </TableCell>  
              </TableRow>
            </TableBody>}
          </Table>
          </TableContainer>
          { customiziationRequestlist.length > 0 ?
            
          <Box sx={{ 
            display: 'flex', 
            justifyContent: 'flex-start', 
            paddingLeft: { xs: '8px', sm: '16px', md: '20px' },
            overflowX: 'auto'
          }}>
            <TablePagination
              rowsPerPageOptions={[5, 10, 25]}
              component="div"
              count={customiziationRequestlist.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              sx={{
                '& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows': {
                  fontSize: { xs: '0.75rem', sm: '0.875rem' }
                },
                '& .MuiTablePagination-toolbar': {
                  flexWrap: { xs: 'wrap', sm: 'nowrap' },
                  paddingLeft: { xs: '0', sm: '16px' }
                }
              }}
            />
          </Box>
        : "" }
        <Divider />
      </PerfectScrollbar>
    </Card>
  </Box>
  </>
  ) 
};

export default LabList;
